export const lucideIcons = [
    'aarrow-down',
    'aarrow-up',
    'accessibility',
    'activity',
    'activity-square',
    'air-vent',
    'airplay',
    'alarge-small',
    'alarm-check',
    'alarm-clock',
    'alarm-clock-check',
    'alarm-clock-minus',
    'alarm-clock-off',
    'alarm-clock-plus',
    'alarm-minus',
    'alarm-plus',
    'alarm-smoke',
    'album',
    'alert-circle',
    'alert-octagon',
    'alert-triangle',
    'align-center',
    'align-center-horizontal',
    'align-center-vertical',
    'align-end-horizontal',
    'align-end-vertical',
    'align-horizontal-distribute-center',
    'align-horizontal-distribute-end',
    'align-horizontal-distribute-start',
    'align-horizontal-justify-center',
    'align-horizontal-justify-end',
    'align-horizontal-justify-start',
    'align-horizontal-space-around',
    'align-horizontal-space-between',
    'align-justify',
    'align-left',
    'align-right',
    'align-start-horizontal',
    'align-start-vertical',
    'align-vertical-distribute-center',
    'align-vertical-distribute-end',
    'align-vertical-distribute-start',
    'align-vertical-justify-center',
    'align-vertical-justify-end',
    'align-vertical-justify-start',
    'align-vertical-space-around',
    'align-vertical-space-between',
    'ambulance',
    'ampersand',
    'ampersands',
    'amphora',
    'anchor',
    'angry',
    'annoyed',
    'antenna',
    'anvil',
    'aperture',
    'app-window',
    'app-window-mac',
    'apple',
    'archive',
    'archive-restore',
    'archive-x',
    'area-chart',
    'armchair',
    'arrow-big-down',
    'arrow-big-down-dash',
    'arrow-big-left',
    'arrow-big-left-dash',
    'arrow-big-right',
    'arrow-big-right-dash',
    'arrow-big-up',
    'arrow-big-up-dash',
    'arrow-down',
    'arrow-down-az',
    'arrow-down-az',
    'arrow-down-circle',
    'arrow-down-from-line',
    'arrow-down-left',
    'arrow-down-left-from-circle',
    'arrow-down-left-from-square',
    'arrow-down-left-square',
    'arrow-down-narrow-wide',
    'arrow-down-right',
    'arrow-down-right-from-circle',
    'arrow-down-right-from-square',
    'arrow-down-right-square',
    'arrow-down-square',
    'arrow-down-to-dot',
    'arrow-down-to-line',
    'arrow-down-up',
    'arrow-down-wide-narrow',
    'arrow-down-za',
    'arrow-down-za',
    'arrow-down01',
    'arrow-down10',
    'arrow-left',
    'arrow-left-circle',
    'arrow-left-from-line',
    'arrow-left-right',
    'arrow-left-square',
    'arrow-left-to-line',
    'arrow-right',
    'arrow-right-circle',
    'arrow-right-from-line',
    'arrow-right-left',
    'arrow-right-square',
    'arrow-right-to-line',
    'arrow-up',
    'arrow-up-az',
    'arrow-up-az',
    'arrow-up-circle',
    'arrow-up-down',
    'arrow-up-from-dot',
    'arrow-up-from-line',
    'arrow-up-left',
    'arrow-up-left-from-circle',
    'arrow-up-left-from-square',
    'arrow-up-left-square',
    'arrow-up-narrow-wide',
    'arrow-up-right',
    'arrow-up-right-from-circle',
    'arrow-up-right-from-square',
    'arrow-up-right-square',
    'arrow-up-square',
    'arrow-up-to-line',
    'arrow-up-wide-narrow',
    'arrow-up-za',
    'arrow-up-za',
    'arrow-up01',
    'arrow-up10',
    'arrows-up-from-line',
    'asterisk',
    'asterisk-square',
    'at-sign',
    'atom',
    'audio-lines',
    'audio-waveform',
    'award',
    'axe',
    'axis3d',
    'axis3d',
    'baby',
    'backpack',
    'badge',
    'badge-alert',
    'badge-cent',
    'badge-check',
    'badge-dollar-sign',
    'badge-euro',
    'badge-help',
    'badge-indian-rupee',
    'badge-info',
    'badge-japanese-yen',
    'badge-minus',
    'badge-percent',
    'badge-plus',
    'badge-pound-sterling',
    'badge-question-mark',
    'badge-russian-ruble',
    'badge-swiss-franc',
    'badge-turkish-lira',
    'badge-x',
    'baggage-claim',
    'balloon',
    'ban',
    'banana',
    'bandage',
    'banknote',
    'banknote-arrow-down',
    'banknote-arrow-up',
    'banknote-x',
    'bar-chart',
    'bar-chart-big',
    'bar-chart-horizontal',
    'bar-chart-horizontal-big',
    'bar-chart2',
    'bar-chart3',
    'bar-chart4',
    'barcode',
    'barrel',
    'baseline',
    'bath',
    'battery',
    'battery-charging',
    'battery-full',
    'battery-low',
    'battery-medium',
    'battery-plus',
    'battery-warning',
    'beaker',
    'bean',
    'bean-off',
    'bed',
    'bed-double',
    'bed-single',
    'beef',
    'beer',
    'beer-off',
    'bell',
    'bell-dot',
    'bell-electric',
    'bell-minus',
    'bell-off',
    'bell-plus',
    'bell-ring',
    'between-horizonal-end',
    'between-horizonal-start',
    'between-horizontal-end',
    'between-horizontal-start',
    'between-vertical-end',
    'between-vertical-start',
    'biceps-flexed',
    'bike',
    'binary',
    'binoculars',
    'biohazard',
    'bird',
    'birdhouse',
    'bitcoin',
    'blend',
    'blinds',
    'blocks',
    'bluetooth',
    'bluetooth-connected',
    'bluetooth-off',
    'bluetooth-searching',
    'bold',
    'bolt',
    'bomb',
    'bone',
    'book',
    'book-a',
    'book-alert',
    'book-audio',
    'book-check',
    'book-copy',
    'book-dashed',
    'book-down',
    'book-headphones',
    'book-heart',
    'book-image',
    'book-key',
    'book-lock',
    'book-marked',
    'book-minus',
    'book-open',
    'book-open-check',
    'book-open-text',
    'book-plus',
    'book-search',
    'book-template',
    'book-text',
    'book-type',
    'book-up',
    'book-up2',
    'book-user',
    'book-x',
    'bookmark',
    'bookmark-check',
    'bookmark-minus',
    'bookmark-plus',
    'bookmark-x',
    'boom-box',
    'bot',
    'bot-message-square',
    'bot-off',
    'bottle-wine',
    'bow-arrow',
    'box',
    'box-select',
    'boxes',
    'braces',
    'brackets',
    'brain',
    'brain-circuit',
    'brain-cog',
    'brick-wall',
    'brick-wall-fire',
    'brick-wall-shield',
    'briefcase',
    'briefcase-business',
    'briefcase-conveyor-belt',
    'briefcase-medical',
    'bring-to-front',
    'brush',
    'brush-cleaning',
    'bubbles',
    'bug',
    'bug-off',
    'bug-play',
    'building',
    'building2',
    'bus',
    'bus-front',
    'cable',
    'cable-car',
    'cake',
    'cake-slice',
    'calculator',
    'calendar',
    'calendar-arrow-down',
    'calendar-arrow-up',
    'calendar-check',
    'calendar-check2',
    'calendar-clock',
    'calendar-cog',
    'calendar-days',
    'calendar-fold',
    'calendar-heart',
    'calendar-minus',
    'calendar-minus2',
    'calendar-off',
    'calendar-plus',
    'calendar-plus2',
    'calendar-range',
    'calendar-search',
    'calendar-sync',
    'calendar-x',
    'calendar-x2',
    'calendar1',
    'calendars',
    'camera',
    'camera-off',
    'candlestick-chart',
    'candy',
    'candy-cane',
    'candy-off',
    'cannabis',
    'cannabis-off',
    'captions',
    'captions-off',
    'car',
    'car-front',
    'car-taxi-front',
    'caravan',
    'card-sim',
    'carrot',
    'case-lower',
    'case-sensitive',
    'case-upper',
    'cassette-tape',
    'cast',
    'castle',
    'cat',
    'cctv',
    'chart-area',
    'chart-bar',
    'chart-bar-big',
    'chart-bar-decreasing',
    'chart-bar-increasing',
    'chart-bar-stacked',
    'chart-candlestick',
    'chart-column',
    'chart-column-big',
    'chart-column-decreasing',
    'chart-column-increasing',
    'chart-column-stacked',
    'chart-gantt',
    'chart-line',
    'chart-network',
    'chart-no-axes-column',
    'chart-no-axes-column-decreasing',
    'chart-no-axes-column-increasing',
    'chart-no-axes-combined',
    'chart-no-axes-gantt',
    'chart-pie',
    'chart-scatter',
    'chart-spline',
    'check',
    'check-check',
    'check-circle',
    'check-circle2',
    'check-line',
    'check-square',
    'check-square2',
    'chef-hat',
    'cherry',
    'chess-bishop',
    'chess-king',
    'chess-knight',
    'chess-pawn',
    'chess-queen',
    'chess-rook',
    'chevron-down',
    'chevron-down-circle',
    'chevron-down-square',
    'chevron-first',
    'chevron-last',
    'chevron-left',
    'chevron-left-circle',
    'chevron-left-square',
    'chevron-right',
    'chevron-right-circle',
    'chevron-right-square',
    'chevron-up',
    'chevron-up-circle',
    'chevron-up-square',
    'chevrons-down',
    'chevrons-down-up',
    'chevrons-left',
    'chevrons-left-right',
    'chevrons-left-right-ellipsis',
    'chevrons-right',
    'chevrons-right-left',
    'chevrons-up',
    'chevrons-up-down',
    'chrome',
    'chromium',
    'church',
    'cigarette',
    'cigarette-off',
    'circle',
    'circle-alert',
    'circle-arrow-down',
    'circle-arrow-left',
    'circle-arrow-out-down-left',
    'circle-arrow-out-down-right',
    'circle-arrow-out-up-left',
    'circle-arrow-out-up-right',
    'circle-arrow-right',
    'circle-arrow-up',
    'circle-check',
    'circle-check-big',
    'circle-chevron-down',
    'circle-chevron-left',
    'circle-chevron-right',
    'circle-chevron-up',
    'circle-dashed',
    'circle-divide',
    'circle-dollar-sign',
    'circle-dot',
    'circle-dot-dashed',
    'circle-ellipsis',
    'circle-equal',
    'circle-fading-arrow-up',
    'circle-fading-plus',
    'circle-gauge',
    'circle-help',
    'circle-minus',
    'circle-off',
    'circle-parking',
    'circle-parking-off',
    'circle-pause',
    'circle-percent',
    'circle-pile',
    'circle-play',
    'circle-plus',
    'circle-pound-sterling',
    'circle-power',
    'circle-question-mark',
    'circle-slash',
    'circle-slash2',
    'circle-slashed',
    'circle-small',
    'circle-star',
    'circle-stop',
    'circle-user',
    'circle-user-round',
    'circle-x',
    'circuit-board',
    'citrus',
    'clapperboard',
    'clipboard',
    'clipboard-check',
    'clipboard-clock',
    'clipboard-copy',
    'clipboard-edit',
    'clipboard-list',
    'clipboard-minus',
    'clipboard-paste',
    'clipboard-pen',
    'clipboard-pen-line',
    'clipboard-plus',
    'clipboard-signature',
    'clipboard-type',
    'clipboard-x',
    'clock',
    'clock-alert',
    'clock-arrow-down',
    'clock-arrow-up',
    'clock-check',
    'clock-fading',
    'clock-plus',
    'clock1',
    'clock10',
    'clock11',
    'clock12',
    'clock2',
    'clock3',
    'clock4',
    'clock5',
    'clock6',
    'clock7',
    'clock8',
    'clock9',
    'closed-caption',
    'cloud',
    'cloud-alert',
    'cloud-backup',
    'cloud-check',
    'cloud-cog',
    'cloud-download',
    'cloud-drizzle',
    'cloud-fog',
    'cloud-hail',
    'cloud-lightning',
    'cloud-moon',
    'cloud-moon-rain',
    'cloud-off',
    'cloud-rain',
    'cloud-rain-wind',
    'cloud-snow',
    'cloud-sun',
    'cloud-sun-rain',
    'cloud-sync',
    'cloud-upload',
    'cloudy',
    'clover',
    'club',
    'code',
    'code-square',
    'code-xml',
    'code2',
    'codepen',
    'codesandbox',
    'coffee',
    'cog',
    'coins',
    'columns',
    'columns-settings',
    'columns2',
    'columns3',
    'columns3cog',
    'columns4',
    'combine',
    'command',
    'compass',
    'component',
    'computer',
    'concierge-bell',
    'cone',
    'construction',
    'contact',
    'contact-round',
    'contact2',
    'container',
    'contrast',
    'cookie',
    'cooking-pot',
    'copy',
    'copy-check',
    'copy-minus',
    'copy-plus',
    'copy-slash',
    'copy-x',
    'copyleft',
    'copyright',
    'corner-down-left',
    'corner-down-right',
    'corner-left-down',
    'corner-left-up',
    'corner-right-down',
    'corner-right-up',
    'corner-up-left',
    'corner-up-right',
    'cpu',
    'creative-commons',
    'credit-card',
    'croissant',
    'crop',
    'cross',
    'crosshair',
    'crown',
    'cuboid',
    'cup-soda',
    'curly-braces',
    'currency',
    'cylinder',
    'dam',
    'database',
    'database-backup',
    'database-zap',
    'decimals-arrow-left',
    'decimals-arrow-right',
    'delete',
    'dessert',
    'diameter',
    'diamond',
    'diamond-minus',
    'diamond-percent',
    'diamond-plus',
    'dice1',
    'dice2',
    'dice3',
    'dice4',
    'dice5',
    'dice6',
    'dices',
    'diff',
    'disc',
    'disc-album',
    'disc2',
    'disc3',
    'divide',
    'divide-circle',
    'divide-square',
    'dna',
    'dna-off',
    'dock',
    'dog',
    'dollar-sign',
    'donut',
    'door-closed',
    'door-closed-locked',
    'door-open',
    'dot',
    'dot-square',
    'download',
    'download-cloud',
    'drafting-compass',
    'drama',
    'dribbble',
    'drill',
    'drone',
    'droplet',
    'droplet-off',
    'droplets',
    'drum',
    'drumstick',
    'dumbbell',
    'ear',
    'ear-off',
    'earth',
    'earth-lock',
    'eclipse',
    'edit',
    'edit2',
    'edit3',
    'egg',
    'egg-fried',
    'egg-off',
    'ellipsis',
    'ellipsis-vertical',
    'equal',
    'equal-approximately',
    'equal-not',
    'equal-square',
    'eraser',
    'ethernet-port',
    'euro',
    'ev-charger',
    'expand',
    'external-link',
    'eye',
    'eye-closed',
    'eye-off',
    'facebook',
    'factory',
    'fan',
    'fast-forward',
    'feather',
    'fence',
    'ferris-wheel',
    'figma',
    'file',
    'file-archive',
    'file-audio',
    'file-audio2',
    'file-axis3d',
    'file-axis3d',
    'file-badge',
    'file-badge2',
    'file-bar-chart',
    'file-bar-chart2',
    'file-box',
    'file-braces',
    'file-braces-corner',
    'file-chart-column',
    'file-chart-column-increasing',
    'file-chart-line',
    'file-chart-pie',
    'file-check',
    'file-check-corner',
    'file-check2',
    'file-clock',
    'file-code',
    'file-code-corner',
    'file-code2',
    'file-cog',
    'file-cog2',
    'file-diff',
    'file-digit',
    'file-down',
    'file-edit',
    'file-exclamation-point',
    'file-headphone',
    'file-heart',
    'file-image',
    'file-input',
    'file-json',
    'file-json2',
    'file-key',
    'file-key2',
    'file-line-chart',
    'file-lock',
    'file-lock2',
    'file-minus',
    'file-minus-corner',
    'file-minus2',
    'file-music',
    'file-output',
    'file-pen',
    'file-pen-line',
    'file-pie-chart',
    'file-play',
    'file-plus',
    'file-plus-corner',
    'file-plus2',
    'file-question',
    'file-question-mark',
    'file-scan',
    'file-search',
    'file-search-corner',
    'file-search2',
    'file-signal',
    'file-signature',
    'file-sliders',
    'file-spreadsheet',
    'file-stack',
    'file-symlink',
    'file-terminal',
    'file-text',
    'file-type',
    'file-type-corner',
    'file-type2',
    'file-up',
    'file-user',
    'file-video',
    'file-video-camera',
    'file-video2',
    'file-volume',
    'file-volume2',
    'file-warning',
    'file-x',
    'file-x2',
    'file-xcorner',
    'files',
    'film',
    'filter',
    'filter-x',
    'fingerprint',
    'fingerprint-pattern',
    'fire-extinguisher',
    'fish',
    'fish-off',
    'fish-symbol',
    'fishing-hook',
    'flag',
    'flag-off',
    'flag-triangle-left',
    'flag-triangle-right',
    'flame',
    'flame-kindling',
    'flashlight',
    'flashlight-off',
    'flask-conical',
    'flask-conical-off',
    'flask-round',
    'flip-horizontal',
    'flip-horizontal2',
    'flip-vertical',
    'flip-vertical2',
    'flower',
    'flower2',
    'focus',
    'fold-horizontal',
    'fold-vertical',
    'folder',
    'folder-archive',
    'folder-check',
    'folder-clock',
    'folder-closed',
    'folder-code',
    'folder-cog',
    'folder-cog2',
    'folder-dot',
    'folder-down',
    'folder-edit',
    'folder-git',
    'folder-git2',
    'folder-heart',
    'folder-input',
    'folder-kanban',
    'folder-key',
    'folder-lock',
    'folder-minus',
    'folder-open',
    'folder-open-dot',
    'folder-output',
    'folder-pen',
    'folder-plus',
    'folder-root',
    'folder-search',
    'folder-search2',
    'folder-symlink',
    'folder-sync',
    'folder-tree',
    'folder-up',
    'folder-x',
    'folders',
    'footprints',
    'fork-knife',
    'fork-knife-crossed',
    'forklift',
    'form',
    'form-input',
    'forward',
    'frame',
    'framer',
    'frown',
    'fuel',
    'fullscreen',
    'function-square',
    'funnel',
    'funnel-plus',
    'funnel-x',
    'gallery-horizontal',
    'gallery-horizontal-end',
    'gallery-thumbnails',
    'gallery-vertical',
    'gallery-vertical-end',
    'gamepad',
    'gamepad-directional',
    'gamepad2',
    'gantt-chart',
    'gantt-chart-square',
    'gauge',
    'gauge-circle',
    'gavel',
    'gem',
    'georgian-lari',
    'ghost',
    'gift',
    'git-branch',
    'git-branch-minus',
    'git-branch-plus',
    'git-commit',
    'git-commit-horizontal',
    'git-commit-vertical',
    'git-compare',
    'git-compare-arrows',
    'git-fork',
    'git-graph',
    'git-merge',
    'git-pull-request',
    'git-pull-request-arrow',
    'git-pull-request-closed',
    'git-pull-request-create',
    'git-pull-request-create-arrow',
    'git-pull-request-draft',
    'github',
    'gitlab',
    'glass-water',
    'glasses',
    'globe',
    'globe-lock',
    'globe-x',
    'globe2',
    'goal',
    'gpu',
    'grab',
    'graduation-cap',
    'grape',
    'grid',
    'grid2x2',
    'grid2x2',
    'grid2x2check',
    'grid2x2check',
    'grid2x2plus',
    'grid2x2plus',
    'grid2x2x',
    'grid2x2x',
    'grid3x2',
    'grid3x3',
    'grid3x3',
    'grip',
    'grip-horizontal',
    'grip-vertical',
    'group',
    'guitar',
    'ham',
    'hamburger',
    'hammer',
    'hand',
    'hand-coins',
    'hand-fist',
    'hand-grab',
    'hand-heart',
    'hand-helping',
    'hand-metal',
    'hand-platter',
    'handbag',
    'handshake',
    'hard-drive',
    'hard-drive-download',
    'hard-drive-upload',
    'hard-hat',
    'hash',
    'hat-glasses',
    'haze',
    'hd',
    'hdmi-port',
    'heading',
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    'headphone-off',
    'headphones',
    'headset',
    'heart',
    'heart-crack',
    'heart-handshake',
    'heart-minus',
    'heart-off',
    'heart-plus',
    'heart-pulse',
    'heater',
    'helicopter',
    'help-circle',
    'helping-hand',
    'hexagon',
    'highlighter',
    'history',
    'home',
    'hop',
    'hop-off',
    'hospital',
    'hotel',
    'hourglass',
    'house',
    'house-heart',
    'house-plug',
    'house-plus',
    'house-wifi',
    'ice-cream',
    'ice-cream-bowl',
    'ice-cream-cone',
    'ice-cream2',
    'id-card',
    'id-card-lanyard',
    'image',
    'image-down',
    'image-minus',
    'image-off',
    'image-play',
    'image-plus',
    'image-up',
    'image-upscale',
    'images',
    'import',
    'inbox',
    'indent',
    'indent-decrease',
    'indent-increase',
    'indian-rupee',
    'infinity',
    'info',
    'inspect',
    'inspection-panel',
    'instagram',
    'italic',
    'iteration-ccw',
    'iteration-cw',
    'japanese-yen',
    'joystick',
    'kanban',
    'kanban-square',
    'kanban-square-dashed',
    'kayak',
    'key',
    'key-round',
    'key-square',
    'keyboard',
    'keyboard-music',
    'keyboard-off',
    'lamp',
    'lamp-ceiling',
    'lamp-desk',
    'lamp-floor',
    'lamp-wall-down',
    'lamp-wall-up',
    'land-plot',
    'landmark',
    'languages',
    'laptop',
    'laptop-minimal',
    'laptop-minimal-check',
    'laptop2',
    'lasso',
    'lasso-select',
    'laugh',
    'layers',
    'layers-plus',
    'layers2',
    'layers3',
    'layout',
    'layout-dashboard',
    'layout-grid',
    'layout-list',
    'layout-panel-left',
    'layout-panel-top',
    'layout-template',
    'leaf',
    'leafy-green',
    'lectern',
    'letter-text',
    'library',
    'library-big',
    'library-square',
    'life-buoy',
    'ligature',
    'lightbulb',
    'lightbulb-off',
    'line-chart',
    'line-squiggle',
    'link',
    'link2',
    'link2off',
    'linkedin',
    'list',
    'list-check',
    'list-checks',
    'list-chevrons-down-up',
    'list-chevrons-up-down',
    'list-collapse',
    'list-end',
    'list-filter',
    'list-filter-plus',
    'list-indent-decrease',
    'list-indent-increase',
    'list-minus',
    'list-music',
    'list-ordered',
    'list-plus',
    'list-restart',
    'list-start',
    'list-todo',
    'list-tree',
    'list-video',
    'list-x',
    'loader',
    'loader-circle',
    'loader-pinwheel',
    'loader2',
    'locate',
    'locate-fixed',
    'locate-off',
    'location-edit',
    'lock',
    'lock-keyhole',
    'lock-keyhole-open',
    'lock-open',
    'log-in',
    'log-out',
    'logs',
    'lollipop',
    'luggage',
    'magnet',
    'mail',
    'mail-check',
    'mail-minus',
    'mail-open',
    'mail-plus',
    'mail-question',
    'mail-question-mark',
    'mail-search',
    'mail-warning',
    'mail-x',
    'mailbox',
    'mails',
    'map',
    'map-minus',
    'map-pin',
    'map-pin-check',
    'map-pin-check-inside',
    'map-pin-house',
    'map-pin-minus',
    'map-pin-minus-inside',
    'map-pin-off',
    'map-pin-pen',
    'map-pin-plus',
    'map-pin-plus-inside',
    'map-pin-x',
    'map-pin-xinside',
    'map-pinned',
    'map-plus',
    'mars',
    'mars-stroke',
    'martini',
    'maximize',
    'maximize2',
    'medal',
    'megaphone',
    'megaphone-off',
    'meh',
    'memory-stick',
    'menu',
    'menu-square',
    'merge',
    'message-circle',
    'message-circle-code',
    'message-circle-dashed',
    'message-circle-heart',
    'message-circle-more',
    'message-circle-off',
    'message-circle-plus',
    'message-circle-question',
    'message-circle-question-mark',
    'message-circle-reply',
    'message-circle-warning',
    'message-circle-x',
    'message-square',
    'message-square-code',
    'message-square-dashed',
    'message-square-diff',
    'message-square-dot',
    'message-square-heart',
    'message-square-lock',
    'message-square-more',
    'message-square-off',
    'message-square-plus',
    'message-square-quote',
    'message-square-reply',
    'message-square-share',
    'message-square-text',
    'message-square-warning',
    'message-square-x',
    'messages-square',
    'mic',
    'mic-off',
    'mic-vocal',
    'mic2',
    'microchip',
    'microscope',
    'microwave',
    'milestone',
    'milk',
    'milk-off',
    'minimize',
    'minimize2',
    'minus',
    'minus-circle',
    'minus-square',
    'monitor',
    'monitor-check',
    'monitor-cloud',
    'monitor-cog',
    'monitor-dot',
    'monitor-down',
    'monitor-off',
    'monitor-pause',
    'monitor-play',
    'monitor-smartphone',
    'monitor-speaker',
    'monitor-stop',
    'monitor-up',
    'monitor-x',
    'moon',
    'moon-star',
    'more-horizontal',
    'more-vertical',
    'motorbike',
    'mountain',
    'mountain-snow',
    'mouse',
    'mouse-off',
    'mouse-pointer',
    'mouse-pointer-ban',
    'mouse-pointer-click',
    'mouse-pointer-square-dashed',
    'mouse-pointer2',
    'mouse-pointer2off',
    'move',
    'move-diagonal',
    'move-diagonal2',
    'move-down',
    'move-down-left',
    'move-down-right',
    'move-horizontal',
    'move-left',
    'move-right',
    'move-up',
    'move-up-left',
    'move-up-right',
    'move-vertical',
    'move3d',
    'move3d',
    'msquare',
    'music',
    'music2',
    'music3',
    'music4',
    'navigation',
    'navigation-off',
    'navigation2',
    'navigation2off',
    'network',
    'newspaper',
    'nfc',
    'non-binary',
    'notebook',
    'notebook-pen',
    'notebook-tabs',
    'notebook-text',
    'notepad-text',
    'notepad-text-dashed',
    'nut',
    'nut-off',
    'octagon',
    'octagon-alert',
    'octagon-minus',
    'octagon-pause',
    'octagon-x',
    'omega',
    'option',
    'orbit',
    'origami',
    'outdent',
    'package',
    'package-check',
    'package-minus',
    'package-open',
    'package-plus',
    'package-search',
    'package-x',
    'package2',
    'paint-bucket',
    'paint-roller',
    'paintbrush',
    'paintbrush-vertical',
    'paintbrush2',
    'palette',
    'palmtree',
    'panda',
    'panel-bottom',
    'panel-bottom-close',
    'panel-bottom-dashed',
    'panel-bottom-inactive',
    'panel-bottom-open',
    'panel-left',
    'panel-left-close',
    'panel-left-dashed',
    'panel-left-inactive',
    'panel-left-open',
    'panel-left-right-dashed',
    'panel-right',
    'panel-right-close',
    'panel-right-dashed',
    'panel-right-inactive',
    'panel-right-open',
    'panel-top',
    'panel-top-bottom-dashed',
    'panel-top-close',
    'panel-top-dashed',
    'panel-top-inactive',
    'panel-top-open',
    'panels-left-bottom',
    'panels-left-right',
    'panels-right-bottom',
    'panels-top-bottom',
    'panels-top-left',
    'paperclip',
    'parentheses',
    'parking-circle',
    'parking-circle-off',
    'parking-meter',
    'parking-square',
    'parking-square-off',
    'party-popper',
    'pause',
    'pause-circle',
    'pause-octagon',
    'paw-print',
    'pc-case',
    'pen',
    'pen-box',
    'pen-line',
    'pen-off',
    'pen-square',
    'pen-tool',
    'pencil',
    'pencil-line',
    'pencil-off',
    'pencil-ruler',
    'pentagon',
    'percent',
    'percent-circle',
    'percent-diamond',
    'percent-square',
    'person-standing',
    'philippine-peso',
    'phone',
    'phone-call',
    'phone-forwarded',
    'phone-incoming',
    'phone-missed',
    'phone-off',
    'phone-outgoing',
    'pi',
    'pi-square',
    'piano',
    'pickaxe',
    'picture-in-picture',
    'picture-in-picture2',
    'pie-chart',
    'piggy-bank',
    'pilcrow',
    'pilcrow-left',
    'pilcrow-right',
    'pilcrow-square',
    'pill',
    'pill-bottle',
    'pin',
    'pin-off',
    'pipette',
    'pizza',
    'plane',
    'plane-landing',
    'plane-takeoff',
    'play',
    'play-circle',
    'play-square',
    'plug',
    'plug-zap',
    'plug-zap2',
    'plug2',
    'plus',
    'plus-circle',
    'plus-square',
    'pocket',
    'pocket-knife',
    'podcast',
    'pointer',
    'pointer-off',
    'popcorn',
    'popsicle',
    'pound-sterling',
    'power',
    'power-circle',
    'power-off',
    'power-square',
    'presentation',
    'printer',
    'printer-check',
    'printer-x',
    'projector',
    'proportions',
    'puzzle',
    'pyramid',
    'qr-code',
    'quote',
    'rabbit',
    'radar',
    'radiation',
    'radical',
    'radio',
    'radio-receiver',
    'radio-tower',
    'radius',
    'rail-symbol',
    'rainbow',
    'rat',
    'ratio',
    'receipt',
    'receipt-cent',
    'receipt-euro',
    'receipt-indian-rupee',
    'receipt-japanese-yen',
    'receipt-pound-sterling',
    'receipt-russian-ruble',
    'receipt-swiss-franc',
    'receipt-text',
    'receipt-turkish-lira',
    'rectangle-circle',
    'rectangle-ellipsis',
    'rectangle-goggles',
    'rectangle-horizontal',
    'rectangle-vertical',
    'recycle',
    'redo',
    'redo-dot',
    'redo2',
    'refresh-ccw',
    'refresh-ccw-dot',
    'refresh-cw',
    'refresh-cw-off',
    'refrigerator',
    'regex',
    'remove-formatting',
    'repeat',
    'repeat1',
    'repeat2',
    'replace',
    'replace-all',
    'reply',
    'reply-all',
    'rewind',
    'ribbon',
    'rocket',
    'rocking-chair',
    'roller-coaster',
    'rose',
    'rotate-ccw',
    'rotate-ccw-key',
    'rotate-ccw-square',
    'rotate-cw',
    'rotate-cw-square',
    'rotate3d',
    'rotate3d',
    'route',
    'route-off',
    'router',
    'rows',
    'rows2',
    'rows3',
    'rows4',
    'rss',
    'ruler',
    'ruler-dimension-line',
    'russian-ruble',
    'sailboat',
    'salad',
    'sandwich',
    'satellite',
    'satellite-dish',
    'saudi-riyal',
    'save',
    'save-all',
    'save-off',
    'scale',
    'scale3d',
    'scale3d',
    'scaling',
    'scan',
    'scan-barcode',
    'scan-eye',
    'scan-face',
    'scan-heart',
    'scan-line',
    'scan-qr-code',
    'scan-search',
    'scan-text',
    'scatter-chart',
    'school',
    'school2',
    'scissors',
    'scissors-line-dashed',
    'scissors-square',
    'scissors-square-dashed-bottom',
    'scooter',
    'screen-share',
    'screen-share-off',
    'scroll',
    'scroll-text',
    'search',
    'search-alert',
    'search-check',
    'search-code',
    'search-slash',
    'search-x',
    'section',
    'send',
    'send-horizonal',
    'send-horizontal',
    'send-to-back',
    'separator-horizontal',
    'separator-vertical',
    'server',
    'server-cog',
    'server-crash',
    'server-off',
    'settings',
    'settings2',
    'shapes',
    'share',
    'share2',
    'sheet',
    'shell',
    'shield',
    'shield-alert',
    'shield-ban',
    'shield-check',
    'shield-close',
    'shield-ellipsis',
    'shield-half',
    'shield-minus',
    'shield-off',
    'shield-plus',
    'shield-question',
    'shield-question-mark',
    'shield-user',
    'shield-x',
    'ship',
    'ship-wheel',
    'shirt',
    'shopping-bag',
    'shopping-basket',
    'shopping-cart',
    'shovel',
    'shower-head',
    'shredder',
    'shrimp',
    'shrink',
    'shrub',
    'shuffle',
    'sidebar',
    'sidebar-close',
    'sidebar-open',
    'sigma',
    'sigma-square',
    'signal',
    'signal-high',
    'signal-low',
    'signal-medium',
    'signal-zero',
    'signature',
    'signpost',
    'signpost-big',
    'siren',
    'skip-back',
    'skip-forward',
    'skull',
    'slack',
    'slash',
    'slash-square',
    'slice',
    'sliders',
    'sliders-horizontal',
    'sliders-vertical',
    'smartphone',
    'smartphone-charging',
    'smartphone-nfc',
    'smile',
    'smile-plus',
    'snail',
    'snowflake',
    'soap-dispenser-droplet',
    'sofa',
    'solar-panel',
    'sort-asc',
    'sort-desc',
    'soup',
    'space',
    'spade',
    'sparkle',
    'sparkles',
    'speaker',
    'speech',
    'spell-check',
    'spell-check2',
    'spline',
    'spline-pointer',
    'split',
    'split-square-horizontal',
    'split-square-vertical',
    'spool',
    'spotlight',
    'spray-can',
    'sprout',
    'square',
    'square-activity',
    'square-arrow-down',
    'square-arrow-down-left',
    'square-arrow-down-right',
    'square-arrow-left',
    'square-arrow-out-down-left',
    'square-arrow-out-down-right',
    'square-arrow-out-up-left',
    'square-arrow-out-up-right',
    'square-arrow-right',
    'square-arrow-up',
    'square-arrow-up-left',
    'square-arrow-up-right',
    'square-asterisk',
    'square-bottom-dashed-scissors',
    'square-chart-gantt',
    'square-check',
    'square-check-big',
    'square-chevron-down',
    'square-chevron-left',
    'square-chevron-right',
    'square-chevron-up',
    'square-code',
    'square-dashed',
    'square-dashed-bottom',
    'square-dashed-bottom-code',
    'square-dashed-kanban',
    'square-dashed-mouse-pointer',
    'square-dashed-top-solid',
    'square-divide',
    'square-dot',
    'square-equal',
    'square-function',
    'square-gantt-chart',
    'square-kanban',
    'square-library',
    'square-m',
    'square-menu',
    'square-minus',
    'square-mouse-pointer',
    'square-parking',
    'square-parking-off',
    'square-pause',
    'square-pen',
    'square-percent',
    'square-pi',
    'square-pilcrow',
    'square-play',
    'square-plus',
    'square-power',
    'square-radical',
    'square-round-corner',
    'square-scissors',
    'square-sigma',
    'square-slash',
    'square-split-horizontal',
    'square-split-vertical',
    'square-square',
    'square-stack',
    'square-star',
    'square-stop',
    'square-terminal',
    'square-user',
    'square-user-round',
    'square-x',
    'squares-exclude',
    'squares-intersect',
    'squares-subtract',
    'squares-unite',
    'squircle',
    'squircle-dashed',
    'squirrel',
    'stamp',
    'star',
    'star-half',
    'star-off',
    'stars',
    'step-back',
    'step-forward',
    'stethoscope',
    'sticker',
    'sticky-note',
    'stone',
    'stop-circle',
    'store',
    'stretch-horizontal',
    'stretch-vertical',
    'strikethrough',
    'subscript',
    'subtitles',
    'sun',
    'sun-dim',
    'sun-medium',
    'sun-moon',
    'sun-snow',
    'sunrise',
    'sunset',
    'superscript',
    'swatch-book',
    'swiss-franc',
    'switch-camera',
    'sword',
    'swords',
    'syringe',
    'table',
    'table-cells-merge',
    'table-cells-split',
    'table-columns-split',
    'table-config',
    'table-of-contents',
    'table-properties',
    'table-rows-split',
    'table2',
    'tablet',
    'tablet-smartphone',
    'tablets',
    'tag',
    'tags',
    'tally1',
    'tally2',
    'tally3',
    'tally4',
    'tally5',
    'tangent',
    'target',
    'telescope',
    'tent',
    'tent-tree',
    'terminal',
    'terminal-square',
    'test-tube',
    'test-tube-diagonal',
    'test-tube2',
    'test-tubes',
    'text',
    'text-align-center',
    'text-align-end',
    'text-align-justify',
    'text-align-start',
    'text-cursor',
    'text-cursor-input',
    'text-initial',
    'text-quote',
    'text-search',
    'text-select',
    'text-selection',
    'text-wrap',
    'theater',
    'thermometer',
    'thermometer-snowflake',
    'thermometer-sun',
    'thumbs-down',
    'thumbs-up',
    'ticket',
    'ticket-check',
    'ticket-minus',
    'ticket-percent',
    'ticket-plus',
    'ticket-slash',
    'ticket-x',
    'tickets',
    'tickets-plane',
    'timer',
    'timer-off',
    'timer-reset',
    'toggle-left',
    'toggle-right',
    'toilet',
    'tool-case',
    'toolbox',
    'tornado',
    'torus',
    'touchpad',
    'touchpad-off',
    'tower-control',
    'toy-brick',
    'tractor',
    'traffic-cone',
    'train',
    'train-front',
    'train-front-tunnel',
    'train-track',
    'tram-front',
    'transgender',
    'trash',
    'trash2',
    'tree-deciduous',
    'tree-palm',
    'tree-pine',
    'trees',
    'trello',
    'trending-down',
    'trending-up',
    'trending-up-down',
    'triangle',
    'triangle-alert',
    'triangle-dashed',
    'triangle-right',
    'trophy',
    'truck',
    'truck-electric',
    'turkish-lira',
    'turntable',
    'turtle',
    'tv',
    'tv-minimal',
    'tv-minimal-play',
    'tv2',
    'twitch',
    'twitter',
    'type',
    'type-outline',
    'umbrella',
    'umbrella-off',
    'underline',
    'undo',
    'undo-dot',
    'undo2',
    'unfold-horizontal',
    'unfold-vertical',
    'ungroup',
    'university',
    'unlink',
    'unlink2',
    'unlock',
    'unlock-keyhole',
    'unplug',
    'upload',
    'upload-cloud',
    'usb',
    'user',
    'user-check',
    'user-check2',
    'user-circle',
    'user-circle2',
    'user-cog',
    'user-cog2',
    'user-lock',
    'user-minus',
    'user-minus2',
    'user-pen',
    'user-plus',
    'user-plus2',
    'user-round',
    'user-round-check',
    'user-round-cog',
    'user-round-minus',
    'user-round-pen',
    'user-round-plus',
    'user-round-search',
    'user-round-x',
    'user-search',
    'user-square',
    'user-square2',
    'user-star',
    'user-x',
    'user-x2',
    'user2',
    'users',
    'users-round',
    'users2',
    'utensils',
    'utensils-crossed',
    'utility-pole',
    'van',
    'variable',
    'vault',
    'vector-square',
    'vegan',
    'venetian-mask',
    'venus',
    'venus-and-mars',
    'verified',
    'vibrate',
    'vibrate-off',
    'video',
    'video-off',
    'videotape',
    'view',
    'voicemail',
    'volleyball',
    'volume',
    'volume-off',
    'volume-x',
    'volume1',
    'volume2',
    'vote',
    'wallet',
    'wallet-cards',
    'wallet-minimal',
    'wallet2',
    'wallpaper',
    'wand',
    'wand-sparkles',
    'wand2',
    'warehouse',
    'washing-machine',
    'watch',
    'waves',
    'waves-arrow-down',
    'waves-arrow-up',
    'waves-ladder',
    'waypoints',
    'webcam',
    'webhook',
    'webhook-off',
    'weight',
    'weight-tilde',
    'wheat',
    'wheat-off',
    'whole-word',
    'wifi',
    'wifi-cog',
    'wifi-high',
    'wifi-low',
    'wifi-off',
    'wifi-pen',
    'wifi-sync',
    'wifi-zero',
    'wind',
    'wind-arrow-down',
    'wine',
    'wine-off',
    'workflow',
    'worm',
    'wrap-text',
    'wrench',
    'x',
    'xcircle',
    'xoctagon',
    'xsquare',
    'youtube',
    'zap',
    'zap-off',
    'zoom-in',
    'zoom-out',
];

// Total: 1910 icons
